import { render, staticRenderFns } from "./cropsManagement.vue?vue&type=template&id=2020f303&scoped=true"
import script from "./cropsManagement.vue?vue&type=script&lang=js"
export * from "./cropsManagement.vue?vue&type=script&lang=js"
import style0 from "./cropsManagement.vue?vue&type=style&index=0&id=2020f303&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020f303",
  null
  
)

export default component.exports